module.exports = __webpack_public_path__ + "static/media/Conexie-2.73047b54.webp";